export default "/fonts/parisienne-regular-webfont.woff2?90f302647e7832749e7735f6f9cb3d3d";